import educationEn from './education.en';

export default educationEn;
